import { apiRequest, ApiResponse } from './api';

export interface ChamadoCategoria {
  id: number;
  nome: string;
  ativo: boolean;
  cor?: string;
  icone?: string;
  createdAt: string;
  updatedAt: string;
}

class ChamadoCategoriaService {
  private baseUrl = '/chamados-categorias';

  async getAll(): Promise<ApiResponse<ChamadoCategoria[]>> {
    return apiRequest.get<ChamadoCategoria[]>(this.baseUrl);
  }

  async create(data: Partial<ChamadoCategoria>): Promise<ApiResponse<ChamadoCategoria>> {
    return apiRequest.post<ChamadoCategoria>(this.baseUrl, data);
  }

  async update(id: number, data: Partial<ChamadoCategoria>): Promise<ApiResponse<ChamadoCategoria>> {
    return apiRequest.put<ChamadoCategoria>(`${this.baseUrl}/${id}`, data);
  }

  async delete(id: number): Promise<ApiResponse<void>> {
    return apiRequest.delete(`${this.baseUrl}/${id}`);
  }
}

export const chamadoCategoriaService = new ChamadoCategoriaService();
export default chamadoCategoriaService;
